import React from 'react';
import Styles from './index.module.scss';
import { ReactComponent as IconWarn } from '@/images/icons/icon-warn.svg';
import { Tooltip } from 'antd';
import { getIn18Text } from 'api';
const ReceiverUnreadItem = (props) => {
    const { text } = props;
    return (React.createElement("div", { className: Styles.receiverUnreadItem },
        React.createElement("div", null, text),
        React.createElement(Tooltip, { title: getIn18Text('MAIL_RECEIVER_UNREAD_TIP') },
            React.createElement("span", { className: Styles.receiverUnreadItemIcon },
                React.createElement(IconWarn, { style: { cursor: 'pointer', marginLeft: '5px', width: '13px', height: '13px' } })))));
};
export default ReceiverUnreadItem;
